var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgBlockUser(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 9.72a7.907 7.907 0 01-.229 1.904 7.493 7.493 0 01-7.207 5.818 6.804 6.804 0 01-1.36-.134A7.65 7.65 0 015.057 9.72a7.666 7.666 0 015.673-7.504l.398-.09c.235-.044.481-.078.728-.1.246-.023.414 0 .627 0A7.577 7.577 0 0119.92 9.72z",
    fill: "#F7C694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.188 9.719a7.907 7.907 0 01-.23 1.904 7.57 7.57 0 01-5.835 5.684 7.65 7.65 0 01-6.065-7.588 7.666 7.666 0 015.673-7.504l.398-.09a7.655 7.655 0 016.059 7.594z",
    fill: "#FD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.214 30H4.459c-1.68 0-2.84-1.808-2.347-3.583a11.049 11.049 0 014.727-6.58 5.481 5.481 0 011.725-.706h.257c.118-.008.236-.008.353 0h.196l.269.045c.539.136 1.087.23 1.64.28.365.045.74.067 1.12.078h.135a.722.722 0 01.734.947 9.457 9.457 0 00-.196 1.915 9.278 9.278 0 002.01 5.774 1.12 1.12 0 01-.868 1.83z",
    fill: "#6CD0F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.214 29.996H8.272c-1.68 0-2.839-1.81-2.346-3.584a11.048 11.048 0 014.726-6.58c.205-.137.422-.254.65-.348.364.045.74.068 1.12.079h.134a.722.722 0 01.712.913 9.45 9.45 0 00-.197 1.915 9.278 9.278 0 002.01 5.773 1.12 1.12 0 01-.867 1.832z",
    fill: "#51B5E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.367 30a7.633 7.633 0 100-15.266 7.633 7.633 0 000 15.266z",
    fill: "#FF5959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.128 20.617h-9.526a.51.51 0 00-.51.51v2.475c0 .281.229.51.51.51h9.526a.51.51 0 00.51-.51v-2.475a.51.51 0 00-.51-.51z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 2)",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgBlockUser;